<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=DM+Serif+Display&display=swap');

* {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  box-sizing: border-box;
}

.login-page {
  height: 100vh;
  display: flex;
  background: #ededf8;
  overflow: hidden;
}

/* ── Left brand panel ── */
.brand-panel {
  flex: 0 0 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #1e3592;
  overflow: hidden;
  padding: 40px 48px;
}
.brand-panel::before {
  content: '';
  position: absolute;
  top: -120px;
  right: -120px;
  width: 400px;
  height: 400px;
  border-radius: 50%;
  background: rgba(59,76,192,0.15);
  filter: blur(80px);
}
.brand-panel::after {
  content: '';
  position: absolute;
  bottom: -80px;
  left: -80px;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background: rgba(91,141,239,0.12);
  filter: blur(60px);
}
.brand-content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.brand-logo {
  height: 50px;
  width: auto;
  margin-bottom: 20px;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
}
.brand-section-label {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  font-size: 9px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 3px;
  color: rgba(255,255,255,0.6);
  margin-bottom: 14px;
}
.brand-title {
  font-family: "DM Serif Display", Georgia, serif !important;
  font-size: 26px;
  font-weight: 400;
  color: #ffffff;
  margin-bottom: 12px;
  line-height: 1.3;
}
.brand-title-coral {
  color: #E8726F;
}
.brand-subtitle {
  font-size: 13px;
  color: rgba(255,255,255,0.7);
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: 28px;
}
.starr-acronym {
  display: flex;
  gap: 16px;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
}
.starr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-width: 56px;
}
.starr-letter {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "DM Serif Display", Georgia, serif !important;
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
}
.starr-icon {
  font-size: 18px !important;
  opacity: 0.9;
}
.starr-label {
  font-size: 11px;
  font-weight: 600;
  color: rgba(255,255,255,0.8);
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.brand-footer-text {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  color: rgba(255,255,255,0.45);
  font-size: 12px;
  font-weight: 400;
  z-index: 2;
}

/* ── Right form panel ── */
.form-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 32px;
  position: relative;
  background: #ffffff;
}
.form-bottom-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: #5A5A72;
  margin-top: 20px;
}
.form-bottom-bar a {
  color: #E8726F;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
.form-bottom-bar a:hover {
  text-decoration: underline;
}
.form-wrapper {
  width: 100%;
  max-width: 400px;
}
.form-logo {
  width: 40px;
  height: 40px;
  margin-bottom: 20px;
}
.form-heading {
  font-family: "DM Serif Display", Georgia, serif !important;
  font-size: 26px;
  font-weight: 400;
  color: #1a1a3e;
  margin-bottom: 6px;
}
.form-sub {
  font-size: 14px;
  color: #6b7280;
  font-weight: 400;
  margin-bottom: 24px;
}

/* ── Session conflict banner ── */
.alc-conflict-banner {
  display: flex;
  gap: 12px;
  background: #fffbeb;
  border: 1.5px solid #f59e0b;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 20px;
}
.alc-conflict-icon { font-size: 20px; flex-shrink: 0; line-height: 1.4; }
.alc-conflict-body { flex: 1; }
.alc-conflict-title { font-size: 13px; font-weight: 700; color: #92400e; margin-bottom: 4px; }
.alc-conflict-msg { font-size: 13px; color: #78350f; line-height: 1.5; margin-bottom: 10px; }
.alc-conflict-actions { display: flex; gap: 8px; flex-wrap: wrap; }
.alc-btn-switch {
  background: #1e3592; color: #fff;
  border: none; border-radius: 6px;
  padding: 7px 14px; font-size: 12px; font-weight: 600;
  cursor: pointer; transition: background 0.15s;
}
.alc-btn-switch:hover { background: #162a7a; }
.alc-btn-stay {
  background: transparent; color: #374151;
  border: 1.5px solid #d1d5db; border-radius: 6px;
  padding: 7px 14px; font-size: 12px; font-weight: 600;
  cursor: pointer; transition: background 0.15s;
}
.alc-btn-stay:hover { background: #f3f4f6; }

.input-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
  display: block;
}
.forgot-link {
  color: #3B4CC0;
  font-size: 13px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
}
.forgot-link:hover {
  text-decoration: underline;
}
.sign-in-btn {
  text-transform: none !important;
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.2px !important;
  height: 48px !important;
  border-radius: 10px !important;
  box-shadow: 0 2px 8px rgba(232,114,111,0.3), 0 4px 14px rgba(232,114,111,0.15) !important;
  transition: all 0.2s ease !important;
}
.sign-in-btn:hover {
  box-shadow: 0 4px 14px rgba(232,114,111,0.4), 0 8px 24px rgba(232,114,111,0.2) !important;
  transform: translateY(-1px);
}
.divider-row {
  display: flex;
  align-items: center;
  gap: 14px;
  color: #9A96A8;
  font-size: 12px;
  margin: 16px 0;
}
.divider-row::before, .divider-row::after {
  content: '';
  flex: 1;
  height: 1px;
  background: #EEECF5;
}
.links-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  color: #5A5A72;
}
.links-sep {
  color: #EEECF5;
}
.link-a {
  color: #3B4CC0;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}
.link-a:hover {
  text-decoration: underline;
}
.form-footer {
  margin-top: 24px;
  text-align: center;
  font-size: 12px;
  color: #9A96A8;
}
.form-footer a {
  color: #5A5A72;
  text-decoration: none;
}
.form-footer a:hover {
  text-decoration: underline;
}

/* ══════════════════════════════════════════════
   MOBILE RESPONSIVE — NO SCROLL, ALL CONTENT
   Strategy: compress sizes based on screen height
   All elements remain visible. Only on extreme
   short screens (<= 660px) subtitle is hidden.
   ══════════════════════════════════════════════ */

/* ── Base mobile layout (≤960px width, all heights) ── */
@media (max-width: 960px) {
  .login-page {
    flex-direction: column;
    overflow: hidden;
  }

  /* Brand panel: proportional height so form panel isn't too empty */
  .brand-panel {
    flex: 0 0 28vh;
    min-height: auto;
    padding: 14px 24px;
    justify-content: center;
    align-items: center;
  }
  .starr-acronym,
  .brand-footer-text {
    display: none;
  }
  .brand-logo {
    height: 45px;
    width: auto;
    margin-bottom: 3px;
  }
  .brand-section-label {
    font-size: 8px;
    margin-bottom: 4px;
  }
  .brand-title {
    font-size: 15px;
    margin-bottom: 6px;
    line-height: 1.25;
  }
  .brand-subtitle {
    display: none;
  }

  /* Form panel: fills remaining space, all items visible */
  .form-panel {
    flex: 1;
    min-height: 0;
    padding: 16px 24px;
    justify-content: center;
    overflow: hidden;
  }
  .form-wrapper {
    max-width: 100%;
  }
  .form-heading {
    font-size: 18px;
    margin-bottom: 2px;
  }
  .form-sub {
    font-size: 11px;
    margin-bottom: 10px;
  }
  .divider-row {
    margin: 8px 0;
  }
  .links-row {
    font-size: 13px;
  }
  .form-footer {
    margin-top: 8px;
    font-size: 11px;
  }
  .form-bottom-bar {
    margin-top: 8px;
    font-size: 12px;
  }
}

/* ── Height 760px–900px: medium phones (iPhone XR, 13, 14) ── */
@media (max-width: 960px) and (min-height: 760px) and (max-height: 900px) {
  .brand-panel {
    flex: 0 0 30vh;
    padding: 18px 28px;
  }
  .brand-logo {
    height: 65px;
    width: auto;
    margin-bottom: 12px;
  }
  .brand-section-label {
    font-size: 10px;
    margin-bottom: 8px;
  }
  .brand-title {
    font-size: 19px;
    line-height: 1.35;
    margin-bottom: 0;
  }
  .brand-subtitle {
    display: none;
  }
  .form-panel {
    padding: 18px 24px;
  }
  .form-heading {
    font-size: 20px;
    margin-bottom: 4px;
  }
  .form-sub {
    font-size: 12px;
    margin-bottom: 12px;
  }
  .divider-row {
    margin: 10px 0;
  }
  .form-footer {
    margin-top: 10px;
    font-size: 12px;
  }
  .form-bottom-bar {
    margin-top: 10px;
  }
}

/* ── Height >900px: large phones (iPhone 14 Pro Max, 15 Plus, big Android) ── */
@media (max-width: 960px) and (min-height: 901px) {
  .brand-panel {
    flex: 0 0 32vh;
    padding: 20px 28px;
  }
  .brand-logo {
    height: 80px;
    width: auto;
    margin-bottom: 16px;
  }
  .brand-section-label {
    font-size: 11px;
    margin-bottom: 10px;
  }
  .brand-title {
    font-size: 24px;
    line-height: 1.35;
    margin-bottom: 0;
  }
  .brand-subtitle {
    display: none;
  }
  .form-panel {
    padding: 24px 24px;
  }
  .form-heading {
    font-size: 22px;
    margin-bottom: 6px;
  }
  .form-sub {
    font-size: 13px;
    margin-bottom: 16px;
  }
  .divider-row {
    margin: 14px 0;
  }
  .form-footer {
    margin-top: 14px;
    font-size: 12px;
  }
  .form-bottom-bar {
    margin-top: 14px;
  }
}

/* ── Height ≤660px: very short (iPhone SE 667px, landscape)
   Only here do we hide subtitle to gain space ── */
@media (max-width: 960px) and (max-height: 660px) {
  .brand-panel {
    padding: 10px 24px;
  }
  .brand-subtitle {
    display: none;
  }
  .brand-section-label {
    display: none;
  }
  .brand-title {
    font-size: 13px;
    margin-bottom: 0;
  }
  .form-panel {
    padding: 12px 24px;
  }
  .form-heading {
    font-size: 16px;
  }
  .form-sub {
    font-size: 10px;
    margin-bottom: 8px;
  }
  .divider-row {
    margin: 6px 0;
  }
  .form-footer {
    margin-top: 6px;
    font-size: 10px;
  }
  .form-bottom-bar {
    margin-top: 6px;
    font-size: 11px;
  }
}

/* ── Height ≤560px: landscape / extreme short — hide brand panel entirely ── */
@media (max-width: 960px) and (max-height: 560px) {
  .brand-panel {
    display: none;
  }
  .form-panel {
    padding: 8px 24px;
  }
}
</style>

<style>
/* ── Vuetify input overrides (unscoped for deep targeting) ── */
.login-page .v-text-field--outlined fieldset {
  border-color: #e0e0f0 !important;
  border-radius: 10px !important;
  border-width: 1.5px !important;
  transition: border-color 0.2s !important;
}
.login-page .v-text-field--outlined.v-input--is-focused fieldset {
  border-color: #3B4CC0 !important;
  border-width: 2px !important;
  box-shadow: 0 0 0 3px rgba(59,76,192,0.08);
}
.login-page .v-input__slot {
  min-height: 44px !important;
  background: #F5F4FA !important;
  border-radius: 10px !important;
  transition: background 0.2s !important;
}
.login-page .v-text-field--outlined.v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}
.login-page .v-text-field {
  text-align: left;
}
.login-page .v-text-field input {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  font-size: 14px;
  font-weight: 400;
  color: #1E1E2F !important;
}
.login-page .v-text-field input::placeholder {
  font-family: "Plus Jakarta Sans", system-ui, sans-serif !important;
  font-size: 14px;
  color: #9ca3af !important;
  font-weight: 400;
  opacity: 1 !important;
}
.login-page .v-text-field input:focus::placeholder {
  opacity: 0.6 !important;
}
.login-page .v-input__prepend-inner,
.login-page .v-input__append-inner {
  margin-top: 12px !important;
}
.login-page .v-input__prepend-inner .v-icon,
.login-page .v-input__append-inner .v-icon {
  color: #9A96A8 !important;
  font-size: 20px !important;
  transition: color 0.2s !important;
}
.login-page .v-text-field--outlined.v-input--is-focused .v-input__prepend-inner .v-icon {
  color: #3B4CC0 !important;
}
</style>

<template>
  <div class="login-page">
    <!-- NOTE: Removed full-screen v-overlay loader to avoid double loading indicator.
         The Sign In button already shows a spinner via :loading="overlay_load". -->

    <!-- Left brand panel -->
    <div class="brand-panel">
      <div class="brand-content">
        <img src="@/assets/starr.png" alt="STARR" class="brand-logo" />
        <p class="brand-section-label">MANAGEMENT OPERATING SYSTEM</p>
        <h1 class="brand-title">Turning enterprise goals into<br/><span class="brand-title-coral">measured results.</span></h1>
        <p class="brand-subtitle">
          STARR is the first Management Operating System that institutionalises ownership, enforces cadence, and makes execution predictable &mdash; so your business runs even when leadership is absent.
        </p>
        <div class="starr-acronym">
          <div class="starr-item">
            <span class="starr-letter" style="background: #3B4CC0;">S</span>
            <v-icon class="starr-icon" style="color: #3B4CC0 !important;">mdi-target</v-icon>
            <span class="starr-label">Strategy</span>
          </div>
          <div class="starr-item">
            <span class="starr-letter" style="background: #4B7BC5;">T</span>
            <v-icon class="starr-icon" style="color: #4B7BC5 !important;">mdi-account-group</v-icon>
            <span class="starr-label">Team</span>
          </div>
          <div class="starr-item">
            <span class="starr-letter" style="background: #E8726F;">A</span>
            <v-icon class="starr-icon" style="color: #E8726F !important;">mdi-flash</v-icon>
            <span class="starr-label">Activate</span>
          </div>
          <div class="starr-item">
            <span class="starr-letter" style="background: #8B6BAE;">R</span>
            <v-icon class="starr-icon" style="color: #8B6BAE !important;">mdi-clipboard-check</v-icon>
            <span class="starr-label">Review</span>
          </div>
          <div class="starr-item">
            <span class="starr-letter" style="background: #0D9488;">R</span>
            <v-icon class="starr-icon" style="color: #0D9488 !important;">mdi-trophy</v-icon>
            <span class="starr-label">Reward</span>
          </div>
        </div>
      </div>
      <div class="brand-footer-text">Trusted by organizations worldwide</div>
    </div>

    <!-- Right form panel -->
    <div class="form-panel">
      <div class="form-wrapper">
        <!-- <img src="@/assets/logo_without_background.png" alt="STARRboard" class="form-logo" /> -->
        <h2 class="form-heading">Welcome back</h2>
        <p class="form-sub">Sign in to continue to your workspace</p>

        <!-- ── Session conflict banner (auto-login from registration) ── -->
        <div v-if="alc_conflict" class="alc-conflict-banner">
          <div class="alc-conflict-icon">⚠️</div>
          <div class="alc-conflict-body">
            <!-- Step 1: initial choice -->
            <template v-if="!alc_confirm_switch">
              <div class="alc-conflict-title">You're already signed in</div>
              <div class="alc-conflict-msg">
                You're signed in as <strong>{{ alc_conflict.existingEmail }}</strong>.
                Your new account was created for <strong>{{ alc_conflict.newEmail }}</strong>.
                What would you like to do?
              </div>
              <div class="alc-conflict-actions">
                <button class="alc-btn-switch" @click="alcSwitchAccount">
                  Switch to new account
                </button>
                <button class="alc-btn-stay" @click="alcKeepExisting">
                  Stay signed in
                </button>
              </div>
            </template>
            <!-- Step 2: confirm before clearing the existing session -->
            <template v-else>
              <div class="alc-conflict-title">Sign out of current account?</div>
              <div class="alc-conflict-msg">
                This will end the session for <strong>{{ alc_conflict.existingEmail }}</strong>
                and sign you in as <strong>{{ alc_conflict.newEmail }}</strong>.
                Any unsaved work in the current session will be lost.
              </div>
              <div class="alc-conflict-actions">
                <button class="alc-btn-switch" @click="alcConfirmSwitch">
                  Yes, switch account
                </button>
                <button class="alc-btn-stay" @click="alc_confirm_switch = false">
                  Cancel
                </button>
              </div>
            </template>
          </div>
        </div>

        <label class="input-label">Email</label>
        <v-text-field
          v-model="email"
          placeholder="you@company.com"
          outlined
          prepend-inner-icon="mdi-email-outline"
          @keypress.enter="$refs.indx_of_pwd.focus()"
          color="#3B4CC0"
          hide-details
          style="margin-bottom: 12px"
          :disabled="overlay_load"
        />

        <label class="input-label">Password</label>
        <v-text-field
          v-model="password"
          placeholder="Enter your password"
          :type="showPassword ? 'text' : 'password'"
          outlined
          ref="indx_of_pwd"
          prepend-inner-icon="mdi-lock-outline"
          :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          @click:append="showPassword = !showPassword"
          @keypress.enter="prefixflag ? $refs.indx_of_perfix.focus() : validate()"
          color="#3B4CC0"
          hide-details
          style="margin-bottom: 8px"
          :disabled="overlay_load"
        />

        <template v-if="prefixflag">
          <label class="input-label">Sub Domain</label>
          <v-text-field
            v-model="prefix"
            placeholder="your-subdomain"
            outlined
            ref="indx_of_perfix"
            prepend-inner-icon="mdi-web"
            @keypress.enter="validate()"
            color="#3B4CC0"
            hide-details
            style="margin-bottom: 16px"
          />
        </template>

        <div class="d-flex justify-end" style="margin-bottom: 16px">
          <span class="forgot-link" @click="forgot">Forgot password?</span>
        </div>

        <v-btn
          block
          dark
          color="#E8726F"
          class="sign-in-btn"
          :loading="overlay_load"
          @click="validate()"
          elevation="0"
        >
          Sign In
        </v-btn>

        <div class="divider-row"><span>or</span></div>

        <div class="links-row">
          <span class="link-a" @click="goPartnerLogin()">Partner login</span>
          <span class="links-sep">·</span>
          <span class="link-a" @click="goPartnerSignup()">Partner signup</span>
        </div>

        <div class="form-footer">
          <span>By signing in, you agree to our </span>
          <a href="https://starrboard.com/terms-of-use" target="_blank">Terms</a>
          <span> &amp; </span>
          <a href="https://starrboard.com/privacy-policy" target="_blank">Privacy Policy</a>
        </div>

        <div class="form-bottom-bar">
          <span>New here?</span>
          <a href="https://starrboard.com/pricing" target="_blank">Create an account</a>
        </div>
      </div>
    </div>

    <SwitchCompanyDialog
      :visible.sync="switch_dialog_visible"
      :entities="domain_login_entities"
      :loading="switch_dialog_loading"
      @confirm="handle_entity_confirmed"
    />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Package from "/package.json";
import emptyProfilePic from "@/assets/Menu/Empty_Profile_Pic.jpg";
import SwitchCompanyDialog from "@/components/SwitchCompanyDialog.vue";
import { processDomainEntitySwitch } from "@/services/loginHelper.js";
export default {
  components: {
    SwitchCompanyDialog
  },
  mounted: function() {
    console.log("new version pushed!!!!");
    // 🚨🚨 IMPORTANT NOTICE 🚨🚨
    // Any change here REQUIRES updating the file below
    // import { handleLogin } from '@/Services/loginHelper.js';
    // console.log('%c🚨🚨 IMPORTANT NOTICE 🚨🚨', 'color: red; font-size: 20px; font-weight: bold;');
    // console.log('%cAny change here REQUIRES updating the file below', 'color: #d32f2f; font-size: 18px; font-weight: 600;');
    // console.log('%cimport { handleLogin } from \'@/Services/loginHelper.js\';', 'color: #1565c0; font-size: 16px; font-weight: 500;');

    let domain = window.location.host.split(".");
    if(domain.length === 0 || domain == null || domain == "" || domain == undefined || domain == "localhost") {
      this.prefixflag = true;
    }

    // NOTE (20260324): Auto-login from website signup redirect
    this.checkAutoLogin();
  },
  data() {
    return {
      applicationVersion: Package.version,
      resultats: null,
      btn: true,
      background: null,
      background_color: "bg",
      card_color: "cardblue",
      login: "login",
      button: "button",
      not: "not",
      forgo: "forgo",
      email: "",
      password: "",
      valid: "",
      domain: "",
      showPassword: false,
      overlay_load: false,
      step: null,
      show_hide_mob_btn: 0,
      full_or_modal: 0,
      window: {
        width: 0,
        height: 0,
      },
      emailRules: [
        (v) => !!v || "E-mail is required", (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/.test(v) ||
        // /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid",
      ],
      checkbox: false,
      mini: false,
      showimage: false,
      window: {
        width: 0,
        height: 0,
      },
      iflag: 0,
      prefix: null,
      prefixflag: false,
      logged_user_id: null,
      // NOTE (20260304150000): login_by_domain flow (starrboard.com)
      switch_dialog_visible: false,
      switch_dialog_loading: false,
      domain_login_entities: [],
      domain_login_email: "",
      // Auto-login context: subdomain from the _alc token so we can bypass the
      // entity-picker dialog and land the user directly in their new workspace.
      alc_subdomain: null,
      // Session conflict: set when an _alc token arrives but a different user is
      // already logged in. Holds { existingEmail, newEmail } until resolved.
      alc_conflict: null,
      alc_confirm_switch: false
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.back();
    // this.resultats = JSON.parse(localStorage.getItem("resultat") || "");
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
    this.back();
  },
  computed: {
    // NOTE (20260304150000): detect starrboard.com to use login_by_domain endpoint
    is_starrboard_login() {
      const host = window.location.hostname;
      return host.includes("starrboard.com") || host.includes("starrboard.in");
    }
  },

  methods: {
    // NOTE (20260324): Decrypt auto-login token from website signup redirect
    _decryptAutoLogin(token, key = 'STARR_2026_ALC') {
      try {
        const encrypted = atob(token);
        let decrypted = '';
        for (let i = 0; i < encrypted.length; i++) {
          decrypted += String.fromCharCode(encrypted.charCodeAt(i) ^ key.charCodeAt(i % key.length));
        }
        const payload = JSON.parse(decrypted);

        // Reject tokens older than 5 minutes (prevent replay)
        if (payload.t && (Date.now() - payload.t) > 5 * 60 * 1000) {
          console.warn('[AutoLogin] Token expired');
          return null;
        }
        return payload;
      } catch (err) {
        console.warn('[AutoLogin] Decryption failed:', err);
        return null;
      }
    },

    // Shared helper called both when there is no conflict and when the user
    // chooses "Switch account" after a conflict is shown.
    _proceedAutoLogin(payload) {
      // Clear any stale session so the new account starts clean.
      localStorage.removeItem('TOKEN');
      localStorage.removeItem('USER_EMAIL');
      localStorage.removeItem('USER_ID');
      localStorage.removeItem('USER_NAME');
      localStorage.removeItem('ALL_ENTITIES');
      localStorage.removeItem('entitydata');

      this.email         = payload.e;
      this.password      = payload.p;
      this.alc_subdomain = payload.d || null;
      this.alc_conflict  = null;

      this.$nextTick(() => {
        this.validate_domain_login();
      });
    },

    // User chose to keep their existing session — discard the _alc token and
    // redirect them into their already-active workspace.
    alcKeepExisting() {
      sessionStorage.removeItem('_alc_redirect');
      this.alc_conflict = null;
      const appUrl = localStorage.getItem('APP_URL') || window.location.origin;
      this.$router.push({ path: '/my_work_inbox' }).catch(() => {
        window.location.href = appUrl;
      });
    },

    // Step 1: user clicks "Switch to new account" — show confirmation first.
    alcSwitchAccount() {
      this.alc_confirm_switch = true;
    },

    // Step 2: user confirmed — clear the existing session and auto-login.
    alcConfirmSwitch() {
      const { payload } = this.alc_conflict;
      this.alc_confirm_switch = false;
      this._proceedAutoLogin(payload);
    },

    // NOTE (20260324): Auto-login from website signup redirect
    checkAutoLogin() {
      const urlParams = new URLSearchParams(window.location.search);
      const alcToken = urlParams.get('_alc');
      const redirectPath = urlParams.get('redirect');

      if (!alcToken) return;

      // Store redirect path before clearing URL params
      if (redirectPath) {
        sessionStorage.setItem('_alc_redirect', redirectPath);
      }

      // Clear URL params immediately (one-time use)
      window.history.replaceState({}, document.title, window.location.pathname);

      const payload = this._decryptAutoLogin(alcToken);
      if (!payload || !payload.e || !payload.p) {
        console.warn('[AutoLogin] Invalid or expired token');
        return;
      }

      console.log('[AutoLogin] Credentials decrypted, auto-logging in...');

      // Detect session conflict: a different user is already logged in.
      const existingToken = localStorage.getItem('TOKEN');
      const existingEmail = (localStorage.getItem('USER_EMAIL') || '').toLowerCase().trim();
      const newEmail      = payload.e.toLowerCase().trim();

      if (existingToken && existingEmail && existingEmail !== newEmail) {
        // Pause auto-login and surface the conflict to the user.
        this.alc_conflict  = { existingEmail, newEmail, payload };
        return;
      }

      // No conflict (no active session, or same email re-logging in).
      this._proceedAutoLogin(payload);
    },
    back() {
        if(this.btn) {
          this.btn = false;
          this.background_color = "bg";
          this.card_color = "cardblue";
          this.login = "login";
          this.button = "button";
          this.not = "not";
          this.forgo = "forgo";
          // this.background = 'bg1'
        } else {
          this.btn = true;
          this.background_color = "bg1";
          this.card_color = "cardwhite";
          this.login = "login1";
          this.button = "button1";
          this.not = "not1";
          this.forgo = "forgo1";
          // this.background = 'bg'
        }
      },
      // handleResize() {
      //   this.window.width = window.innerWidth;
      //   this.window.height = window.innerHeight;
      //   if (this.window.width <= 576) {
      //     this.showimage = true;
      //   } else {
      //     this.showimage = false;
      //   }
      // },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        if(this.window.width <= 576) {
          this.show_hide_mob_btn = 2;
          this.full_or_modal = 1;
        } else {
          this.show_hide_mob_btn = 1;
          this.full_or_modal = 0;
        }
      },
      validate() {
        // Detect subdomain early so admin/devadmin can bypass the domain-login branch
        const _subdomain = this.prefixflag
          ? (this.prefix || "")
          : window.location.host.split(".")[0];

        // NOTE (20260304150000): starrboard.com uses login_by_domain; other domains use old login
        // Exception: admin / devadmin always use the old admin API regardless of TLD
        if (!["admin", "devadmin", "healthcheck"].includes(_subdomain) && this.is_starrboard_login) {
          this.validate_domain_login();
          return;
        }

        if(this.prefixflag) {
          if(!this.prefix) {
            return;
          }
        } else {
          let domain = window.location.host.split(".");
          this.prefix = this.resolvePrefix(domain[0]);
        }

        // NOTE: partner subdomain → public partner login API
        if (this.prefix === "partner") {
          this.validate_partner_login();
          return;
        }

        this.overlay_load = true;
        window.axios = require("axios");
        let mail = this.email;
        if(mail) {
          mail = mail.trim();
        }
        let pass_word = this.password;
        if(pass_word) {
          pass_word = pass_word.trim();
        }
        const login_dataset = {
          email: mail,
          password: pass_word,
          prefix: "cmp_" + this.prefix,
        };
        axios.post("api/sessions/login", login_dataset).then((response) => {
          this.Successdataset(response.data, this.prefix);
        }).catch((error) => {
          this.overlay_load = false;
          this.global_push_toast("error", `[ERR_AUTH_001] ${error.response?.status || "Network"} - Login failed`);
        });
      },

      // NOTE (20260304150000): starrboard.com login — calls login_by_domain then shows selector
      validate_domain_login() {
        const email = this.email ? this.email.trim() : "";
        const password = this.password ? this.password.trim() : "";

        if (!email || !password) {
          this.global_push_toast("error", "[ERR_AUTH_001] Email and password are required");
          return;
        }

        this.overlay_load = true;

        this.$papi.post("sessions/login_by_domain", { email, password })
          .then(res => {
            this.overlay_load = false;
            if (res.data.result !== "success") {
              this.global_push_toast("error", "[ERR_AUTH_001] " + (res.data.message || "Invalid credentials"));
              return;
            }
            this.handle_domain_login_success(res.data);
          })
          .catch(err => {
            this.overlay_load = false;
            const code = err.response?.status || "ERR";
            this.global_push_toast("error", `[ERR_AUTH_002] Login failed (${code})`);
          });
      },

      // NOTE: partner.starrboard.com login — calls public partner_login API
      validate_partner_login() {
        const email    = this.email    ? this.email.trim()    : "";
        const password = this.password ? this.password.trim() : "";

        if (!email || !password) {
          this.global_push_toast("error", "[ERR_AUTH_001] Email and password are required");
          return;
        }

        this.overlay_load = true;

        this.$papi.post("public/partner_login", { email, password })
          .then(res => {
            this.overlay_load = false;
            if (res.data.result !== "success") {
              this.global_push_toast("error", "[ERR_AUTH_001] " + (res.data.message || "Invalid credentials"));
              return;
            }
            const d = res.data;
            localStorage.setItem("resultat",      this.applicationVersion);
            localStorage.setItem("TOKEN",         d.token);
            localStorage.setItem("USER_ID",       d.user_id);
            localStorage.setItem("USER_EMAIL",    d.email);
            localStorage.setItem("USER_NAME",     d.partner_name);
            localStorage.setItem("domain",        "admin");
            localStorage.setItem("PARTNER_ID",    d.partner_id);
            localStorage.setItem("PARTNER_NAME",  d.partner_name);
            localStorage.setItem("COMPANY_NAME",  d.company_name);
            localStorage.setItem("IS_ADMIN",      "false");
            // Store screen & module rights for partner role
            // console.log("PARTNER_LOGIN_DEBUG: user_types_id=", d.user_types_id, "user_type_code=", d.user_type_code);
            // console.log("PARTNER_LOGIN_DEBUG: common_screen_dataset=", JSON.stringify(d.common_screen_dataset));
            localStorage.setItem("COMMON_SCREEN_RIGHT_DATASET", JSON.stringify(d.common_screen_dataset || []));
            localStorage.setItem("SCREEN_RIGHT_DATASET", JSON.stringify([]));
            localStorage.setItem("MODULE_RIGHTS_DATASET", JSON.stringify([]));
            localStorage.setItem("tectalik_product_list", []);
            localStorage.setItem("features_list", []);
            if (d.user_type_code) {
              localStorage.setItem("USER_TYPE", d.user_type_code);
              localStorage.setItem("USER_TYPES", d.user_type_code);
            }
            this.$router.push({ path: "/partner_landing_v2" });
          })
          .catch(err => {
            this.overlay_load = false;
            const code = err.response?.status || "ERR";
            this.global_push_toast("error", `[ERR_AUTH_002] Partner login failed (${code})`);
          });
      },

      handle_domain_login_success(data) {
        const entities = data.entities || [];

        if (!entities.length) {
          this.global_push_toast("error", "[ERR_AUTH_003] No entities found for this account");
          return;
        }

        const sorted_entities = [...entities].sort((a, b) => (a.entity_name || '').localeCompare(b.entity_name || ''));
        this.domain_login_entities = sorted_entities;
        this.domain_login_email = data.user_email;
        // Store for switch company from TopNavBar
        localStorage.setItem("ALL_ENTITIES", JSON.stringify(sorted_entities));

        // Auto-login path: skip the entity picker and go directly into the
        // workspace the user just signed up for.
        if (this.alc_subdomain) {
          // Prefer the entity whose sub_domain matches the registration subdomain;
          // fall back to the first entity if there is only one (new account).
          const match = sorted_entities.find(e => e.sub_domain === this.alc_subdomain)
                     || (sorted_entities.length === 1 ? sorted_entities[0] : null);
          if (match) {
            this.alc_subdomain = null;   // consume — don't affect future manual logins
            this.handle_entity_confirmed(match);
            return;
          }
          // Multiple entities and no subdomain match — fall through to the picker.
          this.alc_subdomain = null;
        }

        this.switch_dialog_visible = true;
      },

      async handle_entity_confirmed(entity) {
        this.switch_dialog_loading = true;
        try {
          await processDomainEntitySwitch(
            this.domain_login_email,
            entity,
            this.$router,
            this,
            "STARR"
          );

          // Success: close the dialog (see TopNavBar.vue's identical fix —
          // if the switch ends in an SPA router.push rather than a full
          // reload, nothing else clears this).
          this.switch_dialog_loading = false;
          this.switch_dialog_visible = false;
        } catch (err) {
          this.switch_dialog_loading = false;
          this.global_push_toast("error", err.message || "[ERR_AUTH_004] Entity switch failed");
        }
      },
      Successdataset(data, domain) {
        localStorage.setItem("resultat", this.applicationVersion);
        if(data.result == "success") {
          localStorage.setItem("TOKEN", data.token);
          let features_list = [];
          let product_list = [];
          let entitydata = [];
          if(!["admin", "devadmin"].includes(domain)) {
            axios.get("tapi/get_features_by_role/" + data.user_id).then(async (response) => {

              // console.log(response.data," response");
              if(response.data.data[0].entity_list.length == 0) {
                this.overlay_load = false;
                alert("Client is Deactivated");
                localStorage.clear();
                return;
              }

              // Clear host dialog flag to ensure dialog can show if needed
              sessionStorage.removeItem("host_dialog_shown");

              localStorage.setItem("entitydata", JSON.stringify(response.data.data[0].entity_list));
              localStorage.setItem("IS_ADMIN", response.data.is_admin.toString());
              localStorage.setItem("IS_CEO", (response.data.is_ceo || false).toString());
              localStorage.setItem("IS_HR", (response.data.is_hr || false).toString());
              localStorage.setItem("CLIENT_COUNTRY", response.data.country || "");
              localStorage.setItem("CLIENT_CURRENCY", response.data.currency || "");
              localStorage.setItem("family_office_flag", response.data.data[0].family_office_flag);
              localStorage.setItem("family_tree_flag", response.data.data[0].family_tree_flag);

              // Flags — keep in sync with loginHelper.js processCompanyLogin
              if(response.data.data){
                localStorage.setItem("CHAIRMAN_FLAG", response.data.data[0].chairman_flag);
                localStorage.setItem("CEO_FLAG", response.data.data[0].ceo_flag);
                localStorage.setItem("SECRETARY_FLAG", response.data.data[0].secretary_flag);
              } else {
                localStorage.setItem("CHAIRMAN_FLAG", false);
                localStorage.setItem("CEO_FLAG", false);
                localStorage.setItem("SECRETARY_FLAG", false);
              }
              localStorage.setItem("is_family_book", "false");
              localStorage.setItem("is_boardpage", "false");
              localStorage.setItem("selected_host_flag", "starr");

              this.getDomainLogo(domain);
              let enty = response.data.data[0].entity_list;
              if(enty.length == 1) {
                localStorage.setItem("ENTITY_ID", enty[0].id);
                localStorage.setItem("entity_name", enty[0].name);
                localStorage.setItem("ENT_FINYEAR", enty[0].financial_year != null ? enty[0].financial_year : "__NA__");
              }
              let employee_dataset = response.data.emp_details;
              localStorage.setItem("Self_Rating_Setting", "yes");
              let content_binary = null;
              if (employee_dataset.length) {
                localStorage.setItem("LOGGED_EMP_ID", employee_dataset[0].id);
                localStorage.setItem("LOGGED_EMP_NO", employee_dataset[0].empno);


                for (let j = 0; j < employee_dataset.length; j++) {
                  let d = employee_dataset[j].profile_pic  || [];
                  if(d.length){
                    if(d[0]?.content_binary){
                     content_binary = d[0]?.content_binary;
                    }
                  }
                }
              } else {
                localStorage.setItem("LOGGED_EMP_ID", 0);
                localStorage.setItem("LOGGED_EMP_NO", 0);
              }
              if(content_binary){
                localStorage.setItem("LOGGED_EMP_PROFILE_IMG", content_binary);
              }else{
                localStorage.setItem("LOGGED_EMP_PROFILE_IMG", emptyProfilePic);
              }
              localStorage.setItem("APPRAISAL_PERIOD_MSTR", JSON.stringify(response.data.appraisal_period_mstr));

              // CUSTOMER_LIST from get_features_by_role response
              const customer = response.data.customer;
              if (Array.isArray(customer) && customer.length > 0) {
                localStorage.setItem("CUSTOMER_LIST", JSON.stringify(customer[0]));
              }

              // kpi_calc
              let calc_settings = response.data.calc_settings;
              if (calc_settings && calc_settings.length) {
                localStorage.setItem("kpi_calc", calc_settings[0].show === true ? "yes" : "no");
              } else {
                localStorage.setItem("kpi_calc", "yes");
              }

              // Self_Rating_Setting (actual value from API)
              let rating_setting = response.data.rating_setting;
              if (rating_setting && rating_setting.length) {
                localStorage.setItem("Self_Rating_Setting", rating_setting[0].self_rating ? "yes" : "no");
              }

              let fl = response.data.data[0].roles_list;
              this.set_local_storage(response.data.modules_by_users, response.data.screen_by_users);
              // products_by_users
              let pl = [];
              let product_list_item = response.data.products_by_users;
              if(product_list_item.length != 0) {
                pl = product_list_item.map((a) => a.product_code);
              } else {
                pl = response.data.data[0].product_list;
              }
              if(fl == "" || fl == null) {
                features_list = [];
              } else {
                features_list = fl;
              }
              if(pl == "" || pl == null) {
                product_list = [];
              } else {
                product_list = pl;
              }
              localStorage.setItem("tectalik_product_list", product_list);
              localStorage.setItem("features_list", features_list);
              localStorage.setItem("USER_ID", data.user_id);
              this.logged_user_id = data.user_id;
              localStorage.setItem("USER_EMAIL", data.user_email);
              localStorage.setItem("USER_NAME", data.user_name);
              localStorage.setItem("BRANCH_ID", response.data.data[0].branch_id);
              var product_get = localStorage.getItem("tectalik_product_list");
              localStorage.setItem("domain", domain);
              product_list = [];
              if(product_get != null && product_get != "" && product_get != undefined && product_get.length != 0) {
                product_list = product_get.split(",");
              }

              if(response.data.data){
                localStorage.setItem("USER_DESIGNATION", response.data.data[0].designation_name);
                localStorage.setItem("DEPT_ID", response.data.data[0].department_id || "");
              }else{
                localStorage.setItem("USER_DESIGNATION", '');
                localStorage.setItem("DEPT_ID", "");
              }

              let targetPath = "/my_work_inbox";

              if(this.window.width <= 576) {
                if(product_list.includes("TECTALIK_FMS")) {
                  targetPath = "/welcome_page";
                } else {
                  targetPath = "/my_work_inbox";
                }
              } else {
                targetPath = "/my_work_inbox";
              }
              if(this.screen_auth('SCN_CEO_DASHBOARD', 'landing')){
                targetPath = "/CEO_DashBoard";
              } else if(this.screen_auth('SCN_EMPLOYEE_DASHBOARD', 'landing')){
                targetPath = "/employeedashboard";
              }
              // Check for post-signup redirect (e.g. /setup_guide)
              const alcRedirect = sessionStorage.getItem('_alc_redirect');
              if (alcRedirect) {
                sessionStorage.removeItem('_alc_redirect');
                targetPath = alcRedirect;
              }
              this.$router.push({
                path: targetPath,
              });

            }
            // this.requestPermission()
            ).catch((error) => console.log(error, "error"));
          } else {
            axios.get("api/get_screen_and_user_data_by_role/", {
              params: {
                user_id: data.user_id,
              },
            }).then((response) => {
              localStorage.setItem("USER_TYPE", response.data.data.user_type_code);
              localStorage.setItem("USER_TYPES", response.data.data.user_type_code);
              let screen_dataset = [];
              let module_dataset = [];
              localStorage.setItem("SCREEN_RIGHT_DATASET", JSON.stringify(screen_dataset));
              localStorage.setItem("MODULE_RIGHTS_DATASET", JSON.stringify(module_dataset));
              let common_screen_dataset = response.data.common_screen_dataset;
              localStorage.setItem("COMMON_SCREEN_RIGHT_DATASET", JSON.stringify(common_screen_dataset));
              localStorage.setItem("tectalik_product_list", product_list);
              localStorage.setItem("features_list", features_list);
              localStorage.setItem("TOKEN", data.token);
              localStorage.setItem("USER_ID", data.user_id);
              this.logged_user_id = data.user_id;
              localStorage.setItem("USER_EMAIL", data.user_email);
              localStorage.setItem("USER_NAME", data.user_name);
              // If common_user has partner_id, treat as partner login
              if (response.data.partner_id) {
                localStorage.setItem("domain", "partner");
                localStorage.setItem("PARTNER_ID", response.data.partner_id);
                localStorage.setItem("PARTNER_EMAIL", data.user_email);
                localStorage.setItem("PARTNER_NAME", data.user_name);
                this.$router.push({ path: "/partner_landing_v2" });
              } else {
                localStorage.setItem("domain", domain);
                this.$router.push({ path: "/admin_landing" });
              }
            }
              // this.requestPermission()
            ).catch((error) => {
              this.overlay_load = false;
              alert("Invalid credentails");
              return;
            });
          }
        } else {
          this.overlay_load = false;
          alert("Invalid credentails");
          return;
        }
      },
      async getDomainLogo(domain) {
        try {
          const res = await this.$papi.get("get_domain_logo_by_domain", {
            params: { domain: domain },
          });
          let logoUrl = null;
          if (res.data.data && res.data.data.logo) {
            // Check if the logo URL is already a full URL
            if (res.data.data.logo.startsWith('https://')) {
              logoUrl = res.data.data.logo;
            } else {
              // If it's a relative path, construct the full URL
              logoUrl = `https://devcdn.tectalik.com/compliance/uploads/original_${res.data.data.logo}`;
              localStorage.setItem("logoUrl", logoUrl);
            }
          } else {
            logoUrl = null;
          }
        } catch (err) {
          console.error("Error fetching logo:", err);
        }
      },
      // Normalize subdomain to the API prefix.
      // devadmin / admin / partner all map to "admin" (public schema).
      // All other subdomains (tenant schemas) pass through unchanged.
      resolvePrefix(subdomain) {
        const s = (subdomain || '').toLowerCase().trim();
        const PUBLIC_SCHEMA_SUBDOMAINS = ['admin', 'devadmin', 'partner', 'healthcheck'];
        return PUBLIC_SCHEMA_SUBDOMAINS.includes(s) ? 'admin' : s;
      },

      goPartnerLogin() {
        const node_env = (process.env.NODE_ENV || 'development').toLowerCase().trim();
        let url;
        if (node_env === 'production') {
          url = "https://partner.starrboard.com/login";
        } else if (node_env === 'development') {
          url = "https://partner.compliance-staging.tectalik.com/login";
        } else {
          // local / lan
          url = "http://partner.starrboard:8080";
        }
        window.location.href = url;
      },

      goPartnerSignup() {
        const node_env = (process.env.NODE_ENV || 'development').toLowerCase().trim();
        let url;
        if (node_env === 'production') {
          url = "https://starrboard.com/partner-signup";
        } else if (node_env === 'development') {
          url = "https://devpartner.starrboard.com/partner-signup";
        } else {
          // local / lan
          url = "http://localhost:3000/partner-signup";
        }
        window.location.href = url;
      },
      forgot() {
        let domain = window.location.host.split(".");
        if(domain[0] == "admin") {
          this.$router.push({
            path: "/forgotpassword_admin?email=" + this.email,
          });
        } else {
          this.$router.push({
            path: "/forgotpassword?email=" + this.email
          });
        }
      },
      set_local_storage(module_dataset = [], screen_dataset = []) {
        localStorage.setItem("MODULE_RIGHTS_DATASET", JSON.stringify(module_dataset));
        for(let i = 0; i < screen_dataset.length; i++) {
          screen_dataset[i]["hide_all"] = false;
          screen_dataset[i]["module_name"] = false;
          for(let j = 0; j < module_dataset.length; j++) {
            if(screen_dataset[i].modules_rights_id == module_dataset[j].id) {
              screen_dataset[i]["hide_all"] = module_dataset[j].active;
              screen_dataset[i]["module_name"] = module_dataset[j].module_name;
            }
          }
        }
        localStorage.setItem("SCREEN_RIGHT_DATASET", JSON.stringify(screen_dataset));
      },
      changetoLowercase($subdomain) {
        this.prefix = this.resolvePrefix($subdomain);
        // console.log(this.prefix,"$prefix");
      },
  },
};
</script>